import { useEffect, useState } from "react";
import { getCachedConfiguration } from "utils/functions/configurationUtil";
import { Promotion } from "interfaces/Promotion";
import { OfferCurrencySale } from "interfaces/OfferCurrencySale";
import { ImFire } from "react-icons/im";
import * as c from "./BoosterModal.module.css";

interface BoosterModalProps {
  campaignCurrencySale?: OfferCurrencySale;
  promotion?: Promotion;
}

function BoosterModal({ campaignCurrencySale, promotion }: BoosterModalProps) {
  const configuration = getCachedConfiguration();

  const [timeLeft, setTimeLeft] = useState<{ days: number; hours: number; minutes: number }>({
    days: 0,
    hours: 0,
    minutes: 0,
  });

  const parseUtc = (date: string) => new Date(date.endsWith("Z") ? date : `${date}Z`).getTime();

  const getActiveSale = () => {
    const publisherSale = configuration?.offersCurrencySale;
    const campaignSale = campaignCurrencySale;

    if (publisherSale?.endOn && campaignSale?.endOn) {
      return parseUtc(publisherSale.endOn) < parseUtc(campaignSale.endOn)
        ? publisherSale
        : campaignSale;
    }

    return publisherSale || campaignSale || null;
  };

  const activeSale = getActiveSale();

  const formatEndDate = (dateString: string) => {
    const date = new Date(dateString.endsWith("Z") ? dateString : `${dateString}Z`);
    const month = date.toLocaleString("en-US", { month: "short" });
    const day = date.getDate();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";

    hours = hours % 12;
    hours = hours ? hours : 12;

    return `Ends ${month} ${day} at ${hours}:${minutes}${ampm}`;
  };

  useEffect(() => {
    if (!activeSale) return;

    const updateTimer = () => {
      const diffMs = parseUtc(activeSale.endOn) - Date.now();

      if (diffMs <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0 });
        return;
      }

      const totalMinutes = Math.floor(diffMs / 60000);
      const totalHours = Math.floor(totalMinutes / 60);

      const days = Math.floor(totalHours / 24);
      const hours = totalHours % 24;
      const minutes = totalMinutes % 60;

      setTimeLeft({ days, hours, minutes });
    };

    updateTimer();
    const interval = setInterval(updateTimer, 60000);

    return () => clearInterval(interval);
  }, [activeSale?.endOn]);

  if (!activeSale) return null;

  return (
    <div className={c.container}>
      <div className={c.infoSection}>
        <div className={c.titleRow}>
          <ImFire className={c.fireIcon} />
          <span className={c.multiplier}>{activeSale?.multiplier}x</span>
          <span>Limited-Time Bonus</span>
        </div>
        <div className={c.dateText}>{formatEndDate(activeSale.endOn)}</div>
      </div>

      <div className={c.timerSection}>
        {timeLeft.days > 0 && (
          <>
            <span className={c.timeBlock}>{timeLeft.days}d</span>
            <span className={c.separator}>:</span>
          </>
        )}
        <span className={c.timeBlock}>{timeLeft.hours}hr</span>
        <span className={c.separator}>:</span>
        <span className={c.timeBlock}>{timeLeft.minutes}m</span>
        <span className={c.remainingText}>Remaining</span>
      </div>
    </div>
  );
}

export default BoosterModal;
